import React from 'react';
import { Translate } from 'react-localize-redux';
import PropTypes from 'prop-types';
import { AutoCompleteField, Button } from '../../components/widgets';
import css from './TopArea.css';
import PermissionsWrapper from '../../containers/PermissionsWrapper';
import InnerTooltip from './InnerTooltip';

const TopArea = ({
    onAppFilterChanged = () => {},
    search = '',
    emptyState = {},
    searching = false,
    filterPlaceholder = 'STATIC.PAGES.MANAGE_LINKS.APP_SEARCH_PLACEHOLDER',
    onClick = () => {},
}) => {
    const filterDisabled = emptyState?.appsFilterDisabled;

    return (
        <div className={css.container}>
            <div className={css.leftSide}>
                <AutoCompleteField
                    options={[]}
                    containerStyle={{ width: 388 }}
                    onInputChange={onAppFilterChanged}
                    onChange={onAppFilterChanged}
                    value={search}
                    placeholder={filterPlaceholder}
                    searchable
                    clearable={!(searching || filterDisabled)}
                    controlled
                    loading={searching}
                    isMulti={false}
                    disabled={filterDisabled}
                    debounceTime={500}
                />
            </div>
            <div className={css.rightSide}>
                <PermissionsWrapper write>
                    <InnerTooltip
                        text="STATIC.PAGES.MANAGE_LINKS.MANAGE_SUBDOMAINS_TOOLTIP"
                        tag="span"
                        className={css.manageDomainsTooltip}
                        popperOptions={{
                            modifiers: {
                                preventOverflow: {
                                    enabled: true,
                                    boundariesElement: 'viewport',
                                    padding: 16,
                                },
                                flip: {
                                    enabled: false,
                                },
                                hide: {
                                    enabled: false,
                                },
                            },
                        }}
                    >
                        <Button type="secondary" onClick={() => onClick('subdomains')}>
                            <Translate id="STATIC.PAGES.MANAGE_LINKS.MANAGE_SUBDOMAINS" />
                        </Button>
                    </InnerTooltip>
                </PermissionsWrapper>
            </div>
        </div>
    );
};

TopArea.propTypes = {
    onAppFilterChanged: PropTypes.func,
    search: PropTypes.string,
    searching: PropTypes.bool,
    onClick: PropTypes.func,
    emptyState: PropTypes.objectOf(PropTypes.any),
    filterPlaceholder: PropTypes.string,
};

export default TopArea;
